import { PlayerConfig } from "../../Config";
import { ILaya } from "../../ILaya";
import { LayaGL } from "../layagl/LayaGL";
import { StatElement } from "../layagl/StatisticsContext";
export class Stat {
    static get FPS() {
        return LayaGL.statAgent.getElementData(StatElement.CT_FPS);
    }
    static show(x, y, views) {
        if (!Stat._statUI)
            Stat._statUI = new Stat._statUIClass();
        this.hide();
        if (views) {
            Stat.elements.length = 0;
            Stat.elements.push(...views);
        }
        if (Stat.elements.length === 0) {
            const statEnum = PlayerConfig.statEnum;
            if (statEnum) {
                for (let k in statEnum) {
                    if (statEnum[k]) {
                        Stat.elements.push(StatElement[k]);
                    }
                }
                Stat.elements.sort();
            }
        }
        if (Stat.elements.length === 0) {
            Stat.elements.push(...defaultElements);
        }
        Stat._show = true;
        Stat._statUI.show();
        Stat._statUI._sp.pos(x || 0, y || 0);
        ILaya.systemTimer.frameLoop(1, null, Stat.loop);
    }
    static hide() {
        if (!Stat._show)
            return;
        Stat._show = false;
        ILaya.timer.clear(null, Stat.loop);
    }
    static loop() {
        if (Stat._show) {
            Stat._statUI.update();
        }
    }
    static render() {
        if (Stat._show)
            Stat._statUI.render();
    }
}
Stat.elements = [];
Stat.loopCount = 0;
Stat.render2DCount = 0;
Stat.enableShadow = true;
Stat.enableMulLight = true;
Stat.enableLight = true;
Stat.enableCameraCMD = true;
Stat.enablePostprocess = true;
Stat.enableSkin = true;
Stat.enableTransparent = true;
Stat.enableParticle = true;
Stat.enableAnimatorUpdate = true;
Stat.enablePhysicsUpdate = true;
Stat.enablemsaa = true;
Stat.enableOpaque = true;
const defaultElements = [
    StatElement.C_Sprite2DCount,
    StatElement.C_Sprite3DCount,
    StatElement.CT_DrawCall,
    StatElement.CT_Triangle,
    StatElement.C_BaseRenderCount,
    StatElement.C_SkinnedMeshRenderCount,
    StatElement.C_ShurikenParticleRenderCount,
    StatElement.T_CullMain,
    StatElement.CT_OpaqueDrawCall,
    StatElement.CT_TransDrawCall,
    StatElement.CT_ShadowDrawCall,
    StatElement.CT_DepthCastDrawCall,
    StatElement.CT_Instancing_DrawCall,
    StatElement.M_GPUMemory,
    StatElement.M_AllTexture,
    StatElement.M_RenderTexture,
    StatElement.M_GPUBuffer
];
window.Stat = Stat;
